import React from "react";
import { Link } from "react-router-dom";
import { WarningIcon } from "@phosphor-icons/react";

export const RISK_TEXT =
  "BotGenomix provides downloadable automated trading software for independent use. It does not provide personalised investment advice or manage customer trading accounts. Trading involves substantial risk, including the potential loss of capital. Past performance and backtested results are not reliable indicators of future performance.";

export const SOFTWARE_POINTS = [
  ["You choose the software", "You decide which bots, if any, to license. We don't recommend bots, markets or instruments for you."],
  ["You install and run it", "The software runs in your own MetaTrader 5 terminal. You decide whether and when to switch it on or off."],
  ["Your own account and broker", "You use your own MT5 account with a broker you choose. We don't select brokers, open accounts for you or receive broker commissions."],
  ["No advice, no account management", "We don't give personalised investment recommendations, trade on your behalf, manage your account or hold your money."],
  ["Fixed strategies", "Each bot's trading rules are fixed when it is released. We don't change them remotely while you use them. The licence check only confirms your licence."],
  ["Your responsibility", "You stay responsible for deciding whether and how to use the software, including the account, size and risk you use."],
];

export function RiskNotice({ testid = "risk-notice", className = "" }) {
  return (
    <div data-testid={testid} role="note"
      className={`flex gap-3 rounded-xl border border-[#FBBF24]/40 bg-[#1A1405]/70 p-4 text-sm leading-relaxed text-[#FDE68A] ${className}`}>
      <WarningIcon size={18} weight="fill" className="mt-0.5 flex-shrink-0 text-[#FBBF24]" />
      <p>
        <b>Important:</b> {RISK_TEXT}{" "}
        <Link to="/legal" className="underline hover:text-white">Full risk information</Link>
      </p>
    </div>
  );
}

export function SoftwareModel({ accent = "#38BDF8" }) {
  return (
    <section data-testid="software-model" className="relative z-10 max-w-[1400px] mx-auto px-6 pb-16">
      <div className="mono text-[11px] uppercase tracking-[0.3em]" style={{ color: accent }}>What BotGenomix is</div>
      <h2 className="text-3xl font-medium tracking-tight mt-2">A software developer, not an investment service.</h2>
      <p className="text-sm text-[#94A3B8] mt-3 max-w-3xl">
        BotGenomix develops, tests and licenses downloadable Expert Advisors (automated trading software) for MetaTrader 5.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {SOFTWARE_POINTS.map(([h, b], i) => (
          <div key={h} data-testid={`software-point-${i}`} className="border border-[#1A1C24] bg-[#0B0D14]/80 rounded-lg p-5">
            <h3 className="font-medium text-[#F1F5F9]">{h}</h3>
            <p className="text-sm text-[#94A3B8] mt-2 leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
      <RiskNotice testid="software-model-risk" className="mt-6" />
    </section>
  );
}
